import React, { useEffect } from "react";
import { View, Card, Text } from "react-native-ui-lib";

export const departmentfields = (response) => {
  const formFields = [
    {
      type: 'divider',
      heading: 'department Details',
      visible: true,
      span: 24,
    },
    {
      label: 'Name',
      key: 'name',
      type: 'text',
      placeholder: 'Enter the department Name',
      visible: true,
      width: '25%',
      required: true,
    },
    {
      label: 'Company',
      key: 'company_id',
      type: 'select',
      placeholder: 'Select the Company',
      visible: true,
      width: '25%',
      options: response.companies || [],
      required: true,
    },
    {
      label: 'Minimum No. of Employees',
      key: 'min_employees',
      type: 'number',
      placeholder: 'Enter the Minimum No. of Employees',
      visible: true,
      width: '25%',
      required: true,
    },

  ];

  const CustomFields = response.CustomFields;

  if (CustomFields && CustomFields.length > 0) {
    CustomFields.forEach((field) => {
      formFields.push({
        label: field.name,
        key: 'cf.' + field.key,
        type: field.type,
        placeholder: field.placeholder,
        visible: true,
        width: '25%'
      });
    });
  }

  return formFields;
}

export const departmentMobileCard = (item, index, getFieldValue) => {
  return <Card flex margin-20 padding-15 className="hh" style={{ height: 100, marginVertical: 10, flexDirection: 'row', flexWrap: 'wrap' }}>
    <View>
      <Text>TEST</Text>
      <Text style={{ marginBottom: 5 }}>{getFieldValue(item, 'name') ? "" + getFieldValue(item, 'name') : ""}</Text>
    </View>
  </Card>;
}

export const departmentMain = {
  fields: departmentfields,
  mobileCard: null
}